import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { createMuiTheme } from "@material-ui/core";
import { ThemeProvider as MuiThemeProvider } from "@material-ui/core/styles";
import CssBaseline from '@material-ui/core/CssBaseline';

export default function ThemeProvider(props) {
  const { children } = props;

  const { filter } = useSelector(state => ({
    filter: state.filter,
  }), shallowEqual);

  const theme = createMuiTheme(
    /**
     * @see https://material-ui.com/customization/themes/#theme-configuration-variables
     */
    {
      breakpoints: {
        values: {
          xs: 0,
          sm: 600,
          md: 900,
          lg: 1500,
          xl: 2200
        },
      },
      // direction: "rtl",
      typography: {
        fontFamily: ["Poppins"].join(",")
      },

      overrides: {
        MuiCssBaseline: {
          '@global': {
            "*::-webkit-scrollbar": {
              //width: 0
              display: 'none'
            }
          }
        },
        // Style sheet name ⚛️
        MuiAutocomplete: {
          // Name of the rule
          groupLabel: {
            // Some CSS
            color: '#eb680e',
          },
        },
      },

      palette: {
        type: filter.theme, // 'light' for light theme, 'dark' for dark theme
        contrastThreshold: 3,
        primary: {
          // light: will be calculated from palette.primary.main,
          main: "#eb680e"
          // dark: will be calculated from palette.primary.main,
          // contrastText: will be calculated to contrast with palette.primary.main
        },
        secondary: {
          // light: will be calculated from palette.primary.main,
          main: "#11998e",
          // dark: will be calculated from palette.primary.main,
          contrastText: "#ffffff"
        },
        error: {
          // light: will be calculated from palette.primary.main,
          main: "#fd397a"
          // dark: will be calculated from palette.primary.main,
          // contrastText: will be calculated to contrast with palette.primary.main
        }
      },

      /**
       * @see https://material-ui.com/customization/globals/#default-props
       */
      props: {
        // Name of the component ⚛️
        MuiButtonBase: {
          // The properties to apply
          disableRipple: true // No more ripple, on the whole application 💣!
        },

        // Set default elevation to 1 for popovers.
        MuiPopover: {
          elevation: 1
        }
      }
    }
  );

  return <MuiThemeProvider theme={theme}><CssBaseline />{children}</MuiThemeProvider>;
}
